import { render, staticRenderFns } from "./CustomerInvoicesTable.vue?vue&type=template&id=30452512&scoped=true&"
import script from "./CustomerInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoicesTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInvoicesTable.vue?vue&type=style&index=0&id=30452512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30452512",
  null
  
)

export default component.exports